import config from '../../config';

import templateUrl from './moreOptionsMenuComponent.html';

class MoreOptionsMenuController {
  SHIFT_TEMPLATES_ENABLED = config.SHIFT_TEMPLATES_ENABLED;

  constructor(
    $location,
    Authentication,
    AlertService,
    EventCollection,
    ShiftsEducation,
    ScheduleTemplatesService,
    ShiftUtils,
    SalesService,
    SlingAnalytics,
    ShiftTasksService,
    ToastShiftsService
  ) {
    'ngInject';

    Object.assign(this, {
      $location,
      Authentication,
      AlertService,
      EventCollection,
      ShiftsEducation,
      ScheduleTemplatesService,
      ShiftUtils,
      SalesService,
      SlingAnalytics,
      ShiftTasksService,
      ToastShiftsService,
    });
  }

  get isShiftTasksTurnedOn() {
    return this.ShiftTasksService.isFeatureTurnedOn;
  }

  async uploadProjectedSales() {
    if (!this.Authentication.user.hasAccessToLaborCost || !this.Authentication.user.org.isPremium) {
      return;
    }

    await this.SalesService.uploadSales();
    this.onProjectedSalesUpdate();
  }

  saveScheduleTemplate() {
    return this.ScheduleTemplatesService.saveScheduleTemplate({
      mode: this.displayMode,
      days: this.currentDays,
      shiftIds: this.selectableShiftIds,
    });
  }

  loadScheduleTemplate() {
    return this.ScheduleTemplatesService.loadScheduleTemplate({
      mode: this.displayMode,
      days: this.currentDays,
    });
  }

  viewShiftTemplates() {
    if (this.Authentication.isOrgFeatureEnabled('shiftTemplates')) {
      this.dropdownOpen = false;
      this.openShiftTemplates();
    }
  }

  viewTaskTemplates() {
    if (this.Authentication.isOrgFeatureEnabled('shiftTasks')) {
      this.dropdownOpen = false;
      this.openTaskTemplates();
    }
  }

  viewTimeBlocks() {
    this.dropdownOpen = false;
    this.openTimeBlocks();
  }

  trackInterest() {
    this.SlingAnalytics.track(this.SlingAnalytics.analyticsEvents.scheduleOptionsButtonClicked);
  }

  activityLogClicked() {
    this.dropdownOpen = false;
    this.toggleActivityLog();
  }

  get displayTab() {
    return this.$location.search().tab;
  }

  get importsDisabled() {
    return this.ToastShiftsService.importsDisabled;
  }

  importToastShiftsSideEffect() {
    this.dropdownOpen = false;
    this.ToastShiftsService.importToastShiftsSideEffect();
  }
}

export default {
  controller: MoreOptionsMenuController,
  controllerAs: 'ctrl',
  bindings: {
    currentDays: '<',
    displayMode: '<',
    dateString: '<',
    selectableShiftIds: '<',
    displayLayoutMode: '<',
    massMakeAvailable: '&',
    onProjectedSalesUpdate: '&',
    dayParts: '<',
    tags: '<',
    getDataForExport: '&',
    worldClockSettingChanged: '&',
    keepCalendarExpandedChanged: '&',
    openShiftTemplates: '&',
    openTaskTemplates: '&',
    openTimeBlocks: '&',
  },
  templateUrl,
};
